import React, { useState, useEffect } from "react";
import { Accordion, Card } from "react-bootstrap";
import {
  productDetailsAccordion, content,
  accordionCard, cardHeader, accordionTitle,
  accordionIcon, accordionBody, rating, clipStar,
  ratingDesc, accordionIconOpen
} from "./style.mod.scss";
import RichText from "components/rich-text";
import { ChevronDown, StarFill } from "react-bootstrap-icons";
import locale from "locales";
import { trackDropdownClick } from "helpers/analytics";
import { getMergedReviewsForCluster } from "data/trusted-reviews";

const PdpFaq = ({ variant, color, variantCluster }) => {
  const [open, setOpen] = useState({});
  const [averageRating, setAverageRating] = useState(null);
  const [totalReviews, setTotalReviews] = useState(0);

  useEffect(() => {
    const fetchReviews = async () => {
      if (!variantCluster || variantCluster.length === 0) return;

      const reviews = await getMergedReviewsForCluster(variantCluster);
      const clusters = variantCluster.map(v => v.cluster).filter(Boolean);
      const filteredReviews = reviews.filter(review =>
        review.cluster && clusters.includes(review.cluster)
      );
      if (filteredReviews.length > 0) {
        const totalScore = filteredReviews.reduce((sum, review) => sum + (review.rating || 0), 0);
        setTotalReviews(filteredReviews.length);
        setAverageRating(totalScore / filteredReviews.length);
      }
    };
    fetchReviews();
  }, [variantCluster]);

  const round = (avg) => avg && Math.round(avg);
  const scrollToReviews = () => document.getElementById("y-product-reviews")?.scrollIntoView({
    behavior: "smooth", block: "start"
  });

  const productInfo = variant?.productInfo;
  const productTabs = productInfo?.productTabs;

  const SummaryReviews = () => {
    if (totalReviews === 0) return <></>;

    return (
      <div onClick={scrollToReviews} className={rating}>
        <div>
          {
            averageRating &&
            Array(round(averageRating)).fill().map((_, index) => (
              <div key={index} className={clipStar}>
                <StarFill />
              </div>
            ))
          }
        </div>
        {
          totalReviews > 0 &&
          <span className={ratingDesc}>({totalReviews} {locale.pages.reviews.reviews})</span>
        }
        <a>{locale.pages.reviews.readReviews}</a>
      </div>
    );
  };

  return (
    <div className={productDetailsAccordion} style={{ backgroundColor: color && color?.hex }}>
      <div className={content}>
        <Accordion className="pointer">
          {
            productTabs?.map((_tab, index) => (
              <Card key={index} className={accordionCard}>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={_tab._key}
                  className={cardHeader}
                  onClick={() => {
                    setOpen(open === _tab._key ? null : _tab._key);
                    trackDropdownClick(open === _tab._key ? "close" : "open", _tab.title);
                  }}
                >
                  <p className={accordionTitle}>{_tab.title}</p>
                  <span className={`${accordionIcon} ${_tab._key !== open ? "" : accordionIconOpen}`}>
                    <ChevronDown />
                  </span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={_tab._key}>
                  <Card.Body className={accordionBody}>
                    <RichText blocks={_tab.content} />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            ))
          }
        </Accordion>
      </div>
      <SummaryReviews />
    </div>
  );
};

export default PdpFaq;
